import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 100%;
  padding: 2rem;
  background-color: #f8f9fa;
`;

export const PrincipalText = styled.h1`
  font-family: 'Poppins', sans-serif;
  font-size: 2.25rem;
  font-weight: 600;
  color: var(--dark-gray);
  margin-bottom: 1rem;
  max-width: 600px;
  line-height: 1.3;
`;

export const SecondaryText = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 1.125rem;
  color: var(--gray, #6c757d);
  max-width: 550px;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

export const ActionButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 45px;
  height: 50px;

  font-size: 1rem; // 16px
  font-weight: 600;
  font-family: 'Poppins', sans-serif;

  color: #ffffff;
  background-color: #9835D1;

  border: none;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;

  transition: background-color 0.3s ease;

  &:hover {
    background-color: #822bad;
  }
`;
